import { Link } from 'react-router-dom';
import head from "../assets/ChatGPT.png"
import AnimatedTagline from './AnimatedTagline';
import { MECCA_TO_CHRIST_URL } from '../data/ministry';

function Header() {
  return (
    <header className="sticky top-0 z-50 bg-white/80 backdrop-blur-md shadow-sm">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between gap-3">
          {/* the wordmark and the parent-ministry credit are separate links —
              an <a> cannot be nested inside another <a> */}
          <div className="flex items-center space-x-3">
            <a href='/'><img src={head} alt='Mecca Prayer House' width={110} height={110}/></a>
            {/* <div className="text-3xl">🕌</div> */}
            <div className="leading-tight">
              <h1 className="text-1xl font-bold bg-yellow-400">
                Mecca Prayer House
              </h1>
              <AnimatedTagline />
              <a
                href={MECCA_TO_CHRIST_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-1 block text-[9.5px] font-semibold uppercase tracking-wide text-yellow-700 transition-colors hover:text-red-500 sm:text-[10px]"
              >
                A ministry of Mecca to Christ International
              </a>
            </div>
          </div>
          
          <nav className="hidden md:flex space-x-8">
            <Link 
              to="/" 
              className="text-gray-700 hover:text-yellow-600 font-medium transition-colors"
            >
              Home
            </Link>
            <Link 
              to="/about" 
              className="text-gray-700 hover:text-yellow-600 font-medium transition-colors"
            >
              About Us
            </Link>
          </nav>
        </div>
      </div>
    </header>
  );
}

export default Header;
